'use strict';

const _=require('pulsar-utils/dist-es6/_');



const ZendeskLinks={
production:{
Trucking:{
documentation:'/hc/en-us/sections/202989206-Trucking-Fatigue-Meter-Documentation-',
learn:'/hc/en-us/sections/203052263-Understand-Fatigue-In-Trucking',
videos:'/hc/en-us/sections/115001645883-Fatigue-Education-Video-Series-',
forum:'/hc/en-us/community/topics',
faq:'/hc/en-us/sections/202995466-FAQ'},

Workforce:{
documentation:'/hc/en-us/sections/360000164223-Workforce-Fatigue-Meter-Documentation',
learn:'/hc/en-us/sections/360000164383-Understanding-Fatigue-Risk',
faq:'/hc/en-us/sections/360000164563-FAQ'},

all:{
message:'/hc/en-us/requests/new'}},


development:{
Trucking:{
documentation:'/hc/en-us/sections/documentation-FAKEURL-TRUCKING',
learn:'/hc/en-us/sections/learn-FAKEURL-TRUCKING',
videos:'/hc/en-us/sections/videos-FAKEURL-TRUCKING',
forum:'/hc/en-us/community/topics',
faq:'/hc/en-us/sections/faq-FAKEURL-TRUCKING'},

Workforce:{
documentation:'/hc/en-us/sections/documentation-FAKEURL-WORKFORCE',
learn:'/hc/en-us/sections/learn-FAKEURL-WORKFORCE',
faq:'/hc/en-us/sections/faq-FAKEURL-WORKFORCE'},

all:{
message:'/hc/en-us/requests/new'}}};




const DefaultEnvironment="production"==='production'?'production':'development';
const _getHelpCenterLinks=function(fatigueMeterType){let environment=arguments.length>1&&arguments[1]!==void 0?arguments[1]:DefaultEnvironment;
const environmentLinks=ZendeskLinks[environment];
const mergedLinks=_.merge({},environmentLinks[fatigueMeterType.value],environmentLinks.all);
return _.mapValues(mergedLinks,function(link){return`/zendesk/login?return_to=${encodeURIComponent('https://pulsar.zendesk.com'+link)}`});
};

module.exports=_getHelpCenterLinks;
//# sourceMappingURL=getHelpCenterLinks.js.map
